import { render, staticRenderFns } from "./WorkerRoleOverview.vue?vue&type=template&id=48985d52"
import script from "./WorkerRoleOverview.vue?vue&type=script&lang=js"
export * from "./WorkerRoleOverview.vue?vue&type=script&lang=js"
import style0 from "./WorkerRoleOverview.vue?vue&type=style&index=0&id=48985d52&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VIcon,VRow})
